// extracted by mini-css-extract-plugin
export default {"container":"rem_IyfCv","salt-shake":"rem_sal_2iotU","star-spin":"rem_sta_2nHmp"};